import classNames from "classnames";
import { useTranslation } from "react-i18next";
import UserBadges from "@components/UserBadges";
import { ReactComponent as IconJoined } from "@assets/ic_joined.svg";
import styles from "../index.module.scss";

import React from "react";

const NewViewerMessage = ({
  author,
  isSupporter,
  isPromoter,
  isMostProfitableSupporter,
  isMostProfitablePromoter,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className={classNames(styles.messageContainer)}>
      <div
        className={classNames(
          styles.avatarContainer,
          "bg-dark-gray d-flex align-items-center justify-content-center",
        )}
      >
        <IconJoined className="text-primary" />
      </div>
      <div className="w-100">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="d-flex">
            <span
              className={classNames(
                "text-body-2 text-semibold",
                styles.chatUsername,
              )}
            >
              {author?.username}
            </span>
            <UserBadges
              isPaid
              isPromoter={isPromoter}
              isSupporter={isSupporter}
              isIdentityVerified={author?.isIdentityVerified}
              isMostProfitablePromoter={isMostProfitablePromoter}
              isMostProfitableSupporter={isMostProfitableSupporter}
            />
          </div>
        </div>
        <span className="text-body-2 text-regular message-description">
          {t("JOINED")}
        </span>
      </div>
    </div>
  );
};

export default NewViewerMessage;
